import { DataGrid } from "@msuite/ui/data-grid";
import { useTranslation } from "@msuite/ui/localization";
import type { BusinessHoursDay } from "@msuite/utils/incoming-invoices";
import { WEEKDAY_TRANSLATION_KEYS } from "./weekday-translation-keys";

/** Props Interface */
interface BusinessHoursSummaryProps {
	hours: Array<BusinessHoursDay>;
}

/** Read-only business hours — the ones a level inherits while it sets none of its own. */
export function BusinessHoursSummary({ hours }: BusinessHoursSummaryProps) {
	/** Context */
	const { t } = useTranslation();

	/** Functions */
	function findDay(weekday: number) {
		for (const day of hours) if (day.weekday === weekday) return day;
		return null;
	}

	/** Render */
	return (
		<DataGrid className="opacity-60">
			{WEEKDAY_TRANSLATION_KEYS.map((key, weekday) => {
				const day = findDay(weekday);
				return (
					<DataGrid.Row key={key}>
						<DataGrid.Label>{t(key)}</DataGrid.Label>
						<DataGrid.Value>
							{day ? `${day.startsAt} – ${day.endsAt}` : t("organization.business_hours_closed")}
						</DataGrid.Value>
					</DataGrid.Row>
				);
			})}
		</DataGrid>
	);
}
